import React, { useRef } from "react";

/**
 * Reusable horizontal drag-scroll container
 *
 * Props:
 * - children: React nodes (content inside the scroll area)
 * - className: optional extra Tailwind classes
 * - speed: optional scroll sensitivity (default = 1)
 */
export default function HorizontalScroll({
  children,
  className = "",
  speed = 1,
  overflow = "overflow-x-auto",
  isShowScrollBar = false,
}) {
  const scrollRef = useRef(null);
  const isDragging = useRef(false);
  const startX = useRef(0);
  const scrollLeft = useRef(0);

  const handleMouseDown = (e) => {
    isDragging.current = true;
    startX.current = e.pageX - scrollRef.current.offsetLeft;
    scrollLeft.current = scrollRef.current.scrollLeft;
    scrollRef.current.style.cursor = "grabbing";
  };

  const handleMouseLeave = () => {
    isDragging.current = false;
    scrollRef.current.style.cursor = "grab";
  };

  const handleMouseUp = () => {
    isDragging.current = false;
    scrollRef.current.style.cursor = "grab";
  };

  const handleMouseMove = (e) => {
    if (!isDragging.current) return;
    e.preventDefault();
    const x = e.pageX - scrollRef.current.offsetLeft;
    const walk = (x - startX.current) * speed;
    scrollRef.current.scrollLeft = scrollLeft.current - walk;
  };

  return (
    <div
      ref={scrollRef}
      onMouseDown={handleMouseDown}
      onMouseLeave={handleMouseLeave}
      onMouseUp={handleMouseUp}
      onMouseMove={handleMouseMove}
      className={`  cursor-grab select-none ${
        isShowScrollBar ? "custom-scrollbar" : "scrollbar-hide"
      } ${className} ${overflow}`}
    >
      {children}
    </div>
  );
}
